import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  readonly defaultDuration: number = 5000;
  constructor(public snackBar: MatSnackBar) {
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: this.defaultDuration,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  openSnackBarWithDuration(message: string, action: string, duration: number) {
    this.snackBar.open(message, action, {
      duration: duration ?? this.defaultDuration,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
}
